export const FileType = {
  Image: 'image',
  Video: 'video',
  Pdf: 'pdf',
  Dicom: 'dicom',
} as const

export type FileType = (typeof FileType)[keyof typeof FileType]
